async function* readNDJSONStream<T>(
  readableStream: ReadableStream,
  intervalMs = 30,
): ReadNDJSONStreamReturn<T> {
  const reader = readableStream.getReader();
  let runningText = '';
  let decoder = new TextDecoder('utf-8');
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    var text = decoder.decode(value, { stream: true });
    const objects = text.split('\n');
    for (const obj of objects) {
      try {
        runningText += obj;
        let result = JSON.parse(runningText) as T;
        yield new Promise<T>((resolve) => {
          setTimeout(() => {
            resolve(result);
          }, intervalMs);
        });
        runningText = '';
      } catch {
        // Not a valid JSON object
      }
    }
  }
}

export { readNDJSONStream };

export type ReadNDJSONStreamReturn<T> = AsyncGenerator<T, void, unknown>;
